<template>
  <div>
    <h5 v-if="title">{{title}}</h5>
    <md-tabs class="tabs" md-alignment="centered">
      <slot />
    </md-tabs>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    title: String,
  },
};
</script>

<style lang="scss">
h5 {
  font-weight: 400;
  font-size: 12px;
  color: #979797;
  margin: 0;
  margin-bottom: 3px;
}
.md-tabs {
  padding: 15px;
  background: #fff;
  border-radius: 8px;

  &.tabs.md-theme-default .md-tabs-indicator {
    height: 40px;
    border-radius: 30px;
    border: 1px solid rgb(255, 95, 60);
    background: transparent;
    bottom: 3px;
    margin: 0 3px;
  }

  .md-button:not([disabled]).md-focused,
  .md-button:not([disabled]).md-active,
  .md-button:not([disabled]):active {
    &:before {
      opacity: 0;
    }

    .md-button-content {
      font-weight: 600;
      color: #ff5f3c;
    }
  }

  .md-button:not([disabled]):hover {
    .md-button-content {
      color: #ff5f3c;
    }

    &:before {
      opacity: 0;
    }
  }

  .md-tabs-navigation {
    .md-button {
      min-width: 58px;
    }
    .md-button-content {
      text-transform: none;
      font-family: "Montserrat", sans-serif;
      font-size: 12px;
      color: #979797;
    }
  }
}
</style>
